import React from 'react';

import { useTypedSelector } from '@/store/store';
import { getShowMoreParams } from '@/store/reducers/cars-stock';
import {
  FiltersWrapper,
  MoreParams,
} from '@/modules/CarsStock/components/common.styles';
import AllParamsButton from '@/modules/CarsStock/components/Mobile/components/AllParamsButton';

import BodyFilter from './components/BodyFilter';
import MileageFilter from './components/MileageFilter';
import PriceFilter from './components/PriceFilter';
import GearboxFilter from './components/GearboxFilter';
import WheelFilter from './components/WheelFilter';
import EngineTypeFilter from './components/EngineTypeFilter';
import EngineCapacityFilter from './components/EngineCapacityFilter';
import BatteryCapacityFilter from './components/BatteryCapacityFilter';
import PowerReserveFilter from './components/PowerReserveFilter';
import SpecialFilter from './components/SpecialFilter';
import EnginePowerFilter from './components/EnginePowerFilter';
import ClearanceFilter from './components/ClearanceFilter';
import SeatsFilter from './components/SeatsFilter';
import DoorsFilter from './components/DoorsFilter';
import ElectricEnginesFilter from './components/ElectricEnginesFilter';

export function ParamsFilterCommercial() {
  const isShowMoreParams = useTypedSelector(getShowMoreParams);

  return (
    <React.Fragment>
      <FiltersWrapper>
        <BodyFilter />
        <MileageFilter />
        <PriceFilter />
        <GearboxFilter />
      </FiltersWrapper>

      <MoreParams isVisible={isShowMoreParams}>
        <FiltersWrapper>
          <WheelFilter />
          <EngineTypeFilter />
          <EngineCapacityFilter />
          <EnginePowerFilter />
          <ClearanceFilter />
          <SeatsFilter />
          <DoorsFilter />
          <BatteryCapacityFilter />
          <PowerReserveFilter />
          <ElectricEnginesFilter />
        </FiltersWrapper>
      </MoreParams>

      <AllParamsButton />

      <SpecialFilter />
    </React.Fragment>
  );
}
